//配置需要用到的element-plus組件  https://juejin.cn/post/7052960030370299940
import "element-plus/dist/index.css";
import {
  ElConfigProvider,
  ElButton,
  ElInput,
  ElRadio,
  ElRadioGroup,
  ElCheckbox,
  ElCheckboxGroup,
  ElSelect,
  ElDatePicker,
  ElCollapse,
  ElCollapseItem,
  ElPagination,
  ElForm,
  ElFormItem,
  ElTable,
  ElTableColumn,
  ElTabPane,
  ElUpload,
  ElOption,
  ElDialog,
  ElTabs,
} from "element-plus";

ElInput.props.placeholder.default = "請輸入";
ElDatePicker.props.placeholder.default = "請選擇";

export const elComponents = [
  ElConfigProvider,
  ElInput,
  ElDatePicker,
  ElCollapse,
  ElCollapseItem,
  ElPagination,
  ElButton,
  ElRadio,
  ElRadioGroup,
  ElCheckbox,
  ElCheckboxGroup,
  ElSelect,
  ElTable,
  ElTableColumn,
  ElForm,
  ElFormItem,
  ElTabPane,
  ElUpload,
  ElOption,
  ElDialog,
  ElTabs,
];
